import { Input } from '@material-tailwind/react'
import { useState } from 'react'
import { toCurrency, toRaw } from '@/utils/money'
import PropTypes from 'prop-types'

// example: <CurrencyInput defaultValue={0} onChangeValue={(value, numericValue) => console.log(value, numericValue)} />
export const CurrencyInput = ({ defaultValue = 0, onChangeValue, ...props }) => {
  const [inputValue, setInputValue] = useState(defaultValue)

  const handleInputChange = (event) => {
    const rawValue = toRaw(event.target.value)
    if (!rawValue) {
      setInputValue(0)
      onChangeValue('', NaN)
      return
    }
    setInputValue(rawValue)

    const numericValue = parseFloat(rawValue)
    if (!isNaN(numericValue)) {
      const formattedValue = toCurrency(numericValue)
      onChangeValue(formattedValue, numericValue)
    } else {
      onChangeValue('', NaN)
    }
  }

  return (
    <Input
      type="text"
      {...props}
      value={toCurrency(inputValue)}
      onChange={handleInputChange}
    />
  )
}

CurrencyInput.propTypes = {
  defaultValue: PropTypes.number,
  onChangeValue: PropTypes.func
}
